import { Button, makeStyles, tokens } from '@fluentui/react-components';
import { ArrowLeft20Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  button: {
    flexShrink: 0,
    minWidth: '36px',
    width: '36px',
    height: '36px',
    padding: 0,
    color: tokens.colorNeutralForeground3,
    backgroundColor: tokens.colorNeutralBackground1,
  },
});

interface BackButtonProps {
  onClick: () => void;
  label?: string;
}

const BackButton = ({ onClick, label }: BackButtonProps) => {
  const { t } = useTranslation();
  const styles = useStyles();
  return (
    <Button
      className={styles.button}
      appearance="outline"
      icon={<ArrowLeft20Regular />}
      aria-label={label ?? t('back', 'Back')}
      onClick={onClick}
    />
  );
};

export default BackButton;
